import classNames from 'classnames';

import Close from '@svg/close.svg';

import s from './ActiveFilter.sss';

type ActiveFilterProps = {
  className?: string;
  onClick?(): void;
};

export const ActiveFilter: React.FC<React.PropsWithChildren<ActiveFilterProps>> = ({
  children,
  className,
  onClick,
}) => (
  <div className={classNames(s.root, className)} onClick={onClick}>
    {children}
    <Close
      className={s.icon}
      width='20'
      height='20'
    />
  </div>
);
